export const frameActionTypes = {
  setShowAnnotation: "SET_SHOW_ANNOTATION",
  setIsDeltaFrameActive: "SET_IS_DELTA_FRAME_ACTIVE",
  setFluoroFrameType: "SET_FLUORO_FRAME_TYPE"
};
